export default {
  categoryInfo: {
    mainTitle: 'Ticari Alacak Sigortası',
    description: {
      title: 'Ticari Alacak Sigortası Nedir?',
      content: [
        'Devlet destekli alacak sigortası, küçük veya orta ölçekli işletmelerin vadeli satışlarından doğan alacaklarının ödenmeme riskine karşı teminat altına alan sigorta ürünüdür.'
      ]
    },
    subContent: {
      title: 'Hangi Alacaklar Teminat Altındadır?',
      content: [
        {
          paragraph: 'Alacak sigortası kapsamında güvence sağlanan durumlar:',
          subList: [
            'Açık hesap, çek ve senet ile yapılan satışlar,',
            'Vadeli faturalı satışlar,',
            'Tüzel kişiliklere (şahıs şirketi, adi ortaklık, vb.) yapılan satışlardır.'
          ]
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Hangi Alacaklar Teminat Dışıdır?',
      content: [
        {
          paragraph: 'Alacak sigortası kapsamında olmayan durumlar:',
          subList: [
            'Peşin olarak yapılan satışlar.',
            'Kredi kartı veya Banka teminatlı satışlar.',
            'Tacir sıfatı taşımayan gerçek kişiler ve kamu kurum ve kuruluşları, belediyeler, odalar ve borsalar, meslek birlikleri, dernekler, vakıflar, kamu iktisadi kuruluşlara yapılan satışlar.'
          ]
        }
      ]
    },
    {
      title: 'Ticari Alacak Sigortası Kimlere Yapılabilir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Kuruluş tarihinden itibaren 2 yıldır devam eden kuruluşlar.',
            'Yıllık cirosu 25 milyon TL’yi aşmayan kuruluşlar.',
            'ORYM (Olağandışı Risk Yönetim Merkezi) tarafından belirlenen risk değerlendirme kriterlerini taşıyan kuruluşlar.'
          ]
        }
      ]
    },
    {
      title: 'Ticari Alacak Sigortası Kimlere Yapılamaz?',
      content: [
        {
          paragraph: null,
          subList: [
            'Kuruluş tarihi üzerinden 2 yıl geçmemiş işletmeler.',
            'Basit usul vergiye tabi olanlar.',
            'SGK prim veya vergi borcu bulunanlar.',
            'Sadece yurt dışına ait alacakları bulunanlar.',
            'Tacir sıfatı taşımayan gerçek kişiler ve kamu kurum ve kuruluşları, belediyeler, odalar ve borsalar, meslek birlikleri, dernekler, vakıflar, kamu iktisadi kuruluşları alacak sigortası yaptıramamaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Risk Değerlendirme İşlemi Ücretli Mi?',
      content: [
        {
          paragraph:
            'ORYM tarafından yapılacak olan risk değerlendirme hizmeti için 10 TL tahsil edilmektedir. Bu ücret sigorta talebinde bulunan kuruluş tarafından ödenmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Ticari Alacak Sigortası Kapsamında Satış Vadeleri Ne Kadar Olmalıdır?',
      content: [
        {
          paragraph:
            'Ticari alacak sigortası kapsamında 120, 180, 240 veya 360 güne kadar vadeli olan satışlarınız kapsam dâhilindedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Neden Ticari Alacak Sigortası Yaptırmalısınız?',
      content: [
        {
          paragraph:
            'Ticari alacak sigortası yaptırarak alacaklarınızı düşünmek yerine işletmenizi büyütmek için adımlar atabilirsiniz.',
          subList: [
            'Yaptırmış olduğunuz sigorta ile kredibiliteniz yükselir.',
            'Sermayeniz için güvence sağlar.',
            'Firmanızın ilerleyen süreçlerdeki mali planlarındaki aksamaları ortadan kaldırır.'
          ]
        }
      ]
    },
    {
      title: 'Ticari Alacak Sigortasında Hangi Alacaklar Teminat Altındadır?',
      content: [
        {
          paragraph:
            'Ticari alacak sigortası sonrasında yapılmış olan satışlardan doğan vadeli alacaklarınız teminat altındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Ticari Alacak Sigortasında Hasar Durumunda Ne Yapılmalıdır?',
      content: [
        {
          paragraph:
            'Alacağın senet veya çeke bağlanması halinde vadenin dolduğu tarihten itibaren 30 gün içerisinde sigorta şirketine bildirmesi gerekmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Alacak açık hesap olarak işlendiği takdirde vadenin dolması üzerine 30 gün koşuluna bağlı kalmak şartı aranmaksızın sigortalı inisiyatifinde 60 gün bekleyerek sigorta şirketine bildirmelidir. Bu süre 60 günü aşmamalıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'Ticari Alacak Sigortası Tanzim Edilmeyen Sektör Bulunuyor Mu?',
      content: [
        {
          paragraph:
            'Devlet Destekli Ticari Alacak Sigortasında sektörler arasında kısıtlama bulunmamaktadır. Tüm sektörlere poliçe düzenlenmektedir.',
          subList: null
        }
      ]
    },
    // {  BURADA TABLO YAPISI OLACAK DAHA SONRA BAKILACAK
    //   title: 'Ticari Alacak Sigortası Nasıl Hesaplanır?',
    //   content: [
    //     {
    //       paragraph:
    //         'Devlet destekli alacak sigortası, vadeli satışlardan elde edilen ciro ve vadenin süresine göre hesaplanmaktadır.',
    //       subList: null
    //     }
    //   ]
    // }
    {
      title: 'Ticari Alacak Sigortası Nasıl Alınır?',
      content: [
        {
          paragraph:
            'İşletmelerde yapılan vadeli satışlardan doğan alacakların ödenmeme riskine karşı sigorta yaptırmak isteyen müşterilerimiz Alokasko.com üzerinden uzmanlarımıza ulaşabilir.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden dolduracağınız başvuru formu ile devlet destekli alacak sigortası hakkında detaylı bilgi alabilir, size en uygun teklifi düzenletebilir ve poliçe tanziminde bulunabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
